import Compressor from "compressorjs";

/**
 * 压缩图片
 * @param {*} file 文件对象
 * @param {*} rule 压缩规则
 * @example
 * compressor(file, {
    quality: 0.8,
    minWidth: 200,
    minHeight: 200,
    convertSize: 2000000
  }).then(res => {
  });
 */
export function compressor(file, rule = {}) {
  return new Promise(function (resolve, reject) {
    let obj = new Compressor(file, {
      ...rule,
      success(res) {
        console.log('【compressor image】success', res);
        // 转化为base64，组装对象
        readFileBase64(res).then((content) => {
          let result = {
            file: res,
            content: content,
            status: file.status
          }
          resolve(result)
        });
      },
      error(err) {
        reject(err)
        console.error('【compressor image】fail', err.message);
      }
    });
  })
}

/**
 * 图片base64
 * @param {*} file 文件对象
 * @param {*} resultType 文件类型
 */
export function readFileBase64(file, resultType = 'base64') {
  return new Promise(function (resolve) {
    if (resultType === 'file') {
      resolve();
      return;
    }

    var reader = new FileReader();
    reader.onload = function (event) {
      resolve(event.target.result);
      console.log(`【image base64】`, event)
    };

    if (resultType === 'base64') {
      reader.readAsDataURL(file);
    } else if (resultType === 'text') {
      reader.readAsText(file);
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/image.js